export default __webpack_public_path__ + "static/media/book.841d8e63.svg";